<template>
  <div class="container">
    <header>
      <LsSupportHeader
        :label="t('serviceScheduled')"
        test-id="long_grass_scheduled_service-title"
      />
    </header>
    <main>
      <h2 test-id="long_grass_scheduled_service-service_scheduled">
        {{ t('longGrass.longGrassScheduled') }}
      </h2>
      <p test-id="long_grass_scheduled_service-service_message_with_return_date">
        {{ t('crewToReturnOnDateToComplete', { returnDate: scheduledDate }) }}
      </p>

      <LsButton
        :text="t('backToMyServices')"
        track-id="long_grass_scheduled_service-back_button"
        test-id="long_grass_scheduled_service-back_button"
        bg-color="primary"
        text-color="white"
        @click="goToMyServices"
      />
    </main>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';
import { LsSupportHeader } from '@/views/Authorized/SupportView/components';
import _ from 'lodash';
import { SERVICE_HISTORY__FILTER_SCHEDULE_EVENT } from '@/store/modules/service-history/types';
import { mapGetters, mapState } from 'vuex';
import { lsFilters } from 'ls-vue-common';
import { lsLongGrassHelpers } from '@/helpers';

export default {
  name: 'LongGrassScheduledServiceView',
  components: { LsButton, LsSupportHeader },
  computed: {
    ...mapState(['serviceHistory']),
    ...mapGetters([SERVICE_HISTORY__FILTER_SCHEDULE_EVENT]),
    scheduleEventId() {
      return this.$route.params.scheduleevent_id;
    },
    scheduledDate() {
      const longGrass = lsLongGrassHelpers.getLongGrassQuoteFromEvent({
        scheduleEvent: this[SERVICE_HISTORY__FILTER_SCHEDULE_EVENT](this.scheduleEventId),
      });

      const serviceScheduleEvent = _.get(longGrass, 'service_schedule_event') || {};
      if (_.isEmpty(serviceScheduleEvent)) return '';

      const [date] = longGrass.service_schedule_event.starts_at.split(' ');
      return lsFilters.date({ date });
    },
  },
  methods: {
    goToMyServices() {
      this.$router.push({ name: 'services' });
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  margin: 0 0 2.5rem;
}
h2 {
  margin-bottom: 2rem;
}
p {
  margin: 3rem 0 2rem;
}
</style>
